<template>
    <span>
        <v-progress-linear indeterminate v-if="isLoading"></v-progress-linear>
        <v-chip color="#f2fbf9" v-for="(item,k) in items" :key="k" @click="updateValue(item.CallerName)" class="ma-1">
            {{item.DrugName}}
        </v-chip>
    </span>
</template>
<script>
import GlicAPI from './GlicAPI.js'
export default {
    props: ['value'],
    data: function() {
        return {
            items: [],
            isLoading: false
        }
    },
    mounted: function() {
        this.getPopularDrugs()
    },
    methods: {
        //emit's an update event so that the parent component can grab the name. 
        updateValue: function(v) {
            this.DrugName = v;
            this.$emit('input', v);
        },
        getPopularDrugs: function() {
            var g = this
            this.isLoading = true;
            GlicAPI.populardrug().then(function(json) {
                g.$set(g, 'items', json[0].data)
                g.isLoading = false
            }).catch(function() {
                g.isLoading = false
            });
        }
    },
    watch: {

    }
}
</script>